import { memo, ReactNode } from 'react';
import styled from 'styled-components';

import AuthFooter from '@/components/Global/layouts/AuthLayout/AuthFooter';
import FreeQuestLogo from '@/components/Global/layouts/AuthLayout/FreeQuestLogo';
import StandardDesktopFooter from '@/components/Global/layouts/StandardLayout/StandardDesktopLayout/StandardDesktopFooter';
import { COLOR, MEDIA_QUERIES_BREAKPOINTS } from '@/globalStyles';

type AuthLayoutCenterProps = {
    className?: string;
    children?: ReactNode;
    hideFooter?: boolean;
    footerPaddingTopMultiplier?: number;
    centerLogo?: boolean;
};

const AuthLayoutCenter = ({ className, hideFooter, children, footerPaddingTopMultiplier }: AuthLayoutCenterProps) => {
    return (
        <div className={className}>
            <FreeQuestLogo />
            <ContentWrapper>{children}</ContentWrapper>
            {hideFooter || <AuthFooter addEnjoyText multiplier={footerPaddingTopMultiplier} />}
            <LoveTextTermsPrivacyPolicy />
        </div>
    );
};

const ContentWrapper = styled.div`
    padding: 0 2rem;
    @media screen and (width < ${MEDIA_QUERIES_BREAKPOINTS.stablet}px) {
        padding: 0 1rem;
    }
`;

const LoveTextTermsPrivacyPolicy = styled(StandardDesktopFooter)`
    & {
        padding-top: 1rem;
        padding-bottom: 1rem;

        & > :first-child {
            padding-left: 2rem;
            padding-right: 1rem;
        }

        & > :last-child {
            padding-left: 1rem;
            padding-right: 2rem;
        }
    }
`;

const Memoized = memo(AuthLayoutCenter);
const Styled = styled(Memoized)<{ centerLogo?: boolean }>`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    min-height: 100vh;
    background: linear-gradient(0.5deg, ${COLOR.aliceBlue} 15%, ${COLOR.white});

    ${FreeQuestLogo} {
        display: flex;
        justify-content: ${({ centerLogo }) => (centerLogo ? 'center' : 'flex-start')};
        width: calc(100vw - 4rem);
        margin: 2rem 0 1rem;
        & svg {
            transform: scale(0.8);
        }
    }
`;

export default Styled;
